// Dispatched actions must return an object with `type` attribute
//  or break redux.
//  GTM integration needs a refactor - either pull out of actions,
//  OR revert some changes and pass event to reducer
//  and have reducer call dataLayer.
const gtmPseudoAction = {
  type: 'TAG_MANAGER',
}

export const tagEvent = (tagCategory, tagAction, tagLabel) => {
  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      event: 'event',
      eventCategory: tagCategory,
      eventAction: tagAction,
      eventLabel: tagLabel,
    })
  }
  return gtmPseudoAction
}

export const tagEngagement = (tagAction, tagLabel) => tagEvent('paperchecker engagements', tagAction, tagLabel)

export const tagFunnel = (tagAction, tagLabel) => tagEvent('paperchecker funnel', tagAction, tagLabel)

export const tagError = (tagAction, tagLabel) => tagEvent('paperchecker error', tagAction, tagLabel)

export const tagAccount = (tagAction, tagLabel) => tagEvent('account', tagAction, tagLabel)

export const tagHelp = (tagAction, tagLabel) => tagEvent('help', tagAction, tagLabel)

export const tagPageview = virtualPath => {
  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      event: 'virtualPage',
      virtualPagePath: virtualPath,
    })
  }
  return gtmPseudoAction
}
